<script setup>
// ============================================================================
// BonBoZ: trang Thống kê > QUẢNG CÁO.
//
// KHÁC RETION/PANCAKE Ở CHỖ NÀO: họ hiện một bảng phẳng "ID quảng cáo | tổng
// SĐT | lượt tiếp cận". Ba vấn đề: ID quảng cáo là chuỗi số không ai nhớ nổi,
// "lượt tiếp cận" là con số đẹp không quyết định được gì, và bảng phẳng thì
// không so được chiến dịch với chiến dịch.
//
// Ở đây:
//   · CÂY campaign ▸ nhóm ▸ ad — gộp ngay trên giao diện, mở ra thu vào được;
//     mỗi cấp cùng một bộ cột nên so ngang được ở mọi tầng
//   · ẢNH CREATIVE + tên ad thay cho dãy số — nhìn là nhận ra ngay ad nào
//   · TỈ LỆ RA SỐ là cột chính, đúng thước của trang Tổng quan
//   · CẢM XÚC theo ad — ad hứa quá lời mang về khách vỡ mộng
//   · dải so QUẢNG CÁO vs TỰ NHIÊN — tiền mua khách có đáng không
//
// Chưa có cột chi phí: cần Meta Insights API, tài khoản chưa được cấp quyền.
// ============================================================================
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import HieuSuatAPI from 'dashboard/api/bonboz/hieuSuat';
import { useAlert } from 'dashboard/composables';
import { useSelectedPages } from 'dashboard/composables/useSelectedPages';
import { useMapGetter } from 'dashboard/composables/store';
import { ngay } from 'dashboard/helper/dinhDangNgay';
import {
  taiXuongExcel,
  tenFileThongKe,
} from 'dashboard/helper/bonboz/xuatExcel';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import BieuDoCamXuc from './BieuDoCamXuc.vue';
import ReportHeader from '../components/ReportHeader.vue';
import OverviewReportFilters from '../components/OverviewReportFilters.vue';
import PhamVi from './PhamVi.vue';

const { t } = useI18n();
const { selectedInboxIds, isAllSelected } = useSelectedPages();
const inboxes = useMapGetter('inboxes/getInboxes');

// Tab phạm vi — cùng khuôn với bốn trang Thống kê kia. Quảng cáo chạy theo
// từng trang Facebook nên soi riêng một trang là câu hỏi có thật.
const bangCua = ref(null); // null = tổng các trang

const cacTrangChon = computed(() => {
  if (isAllSelected.value) return inboxes.value;
  const chon = new Set(selectedInboxIds.value.map(Number));
  return inboxes.value.filter(hop => chon.has(Number(hop.id)));
});

const dangTai = ref(true);
const tong = ref(null);
const soSanh = ref(null);
const chuoiNgay = ref([]);
const cacAd = ref([]);
const tu = ref(null);
const den = ref(null);
const dangMo = ref(new Set());

const tai = async () => {
  if (!tu.value || !den.value) return;
  dangTai.value = true;
  try {
    const { data } = await HieuSuatAPI.quangCao({
      since: tu.value,
      until: den.value,
      inboxIds:
        bangCua.value === null ? selectedInboxIds.value : [bangCua.value],
    });
    tong.value = data.tong;
    soSanh.value = data.so_sanh;
    chuoiNgay.value = data.ngay || [];
    cacAd.value = data.quang_cao || [];
  } catch {
    tong.value = null;
    soSanh.value = null;
    chuoiNgay.value = [];
    cacAd.value = [];
    useAlert(t('BONBOZ.QUANG_CAO.LOI_TAI'));
  } finally {
    dangTai.value = false;
  }
};

watch(selectedInboxIds, () => {
  bangCua.value = null;
  tai();
});

const chonBang = id => {
  bangCua.value = id;
  tai();
};

const doiBoLoc = ({ from, to }) => {
  tu.value = from;
  den.value = to;
  // Đổi khoảng ngày thì quay về Tổng các trang.
  bangCua.value = null;
  tai();
};

const coSoLieu = computed(() => cacAd.value.length > 0);

// Gộp cây NGAY TRÊN GIAO DIỆN từ danh sách phẳng: backend gộp sẵn thì mỗi lần
// đổi cách nhóm phải sửa cả hai đầu. Ad chưa đồng bộ được cây Meta (job chưa
// chạy xong) dồn vào một nhóm "Chưa rõ chiến dịch" chứ không bị giấu đi.
const cay = computed(() => {
  const bang = new Map();
  cacAd.value.forEach(ad => {
    const ten = ad.chien_dich || t('BONBOZ.QUANG_CAO.CHUA_RO');
    if (!bang.has(ten)) bang.set(ten, { ten, khach: 0, sdt: 0, ads: [] });
    const nhom = bang.get(ten);
    nhom.khach += ad.khach;
    nhom.sdt += ad.sdt;
    nhom.ads.push(ad);
  });
  return [...bang.values()]
    .map(n => ({
      ...n,
      ti_le: n.khach ? Math.round((n.sdt / n.khach) * 1000) / 10 : 0,
      ads: [...n.ads].sort((a, b) => b.sdt - a.sdt || b.khach - a.khach),
    }))
    .sort((a, b) => b.sdt - a.sdt || b.khach - a.khach);
});

const doiMo = ten => {
  const moi = new Set(dangMo.value);
  if (moi.has(ten)) moi.delete(ten);
  else moi.add(ten);
  dangMo.value = moi;
};

const nhanBieuDo = computed(() =>
  chuoiNgay.value.map(d => ngay(d.moc * 1000, 'ngayThang'))
);

const xuatExcel = () => {
  taiXuongExcel(tenFileThongKe('thong-ke-quang-cao', tu.value, den.value), [
    [
      t('BONBOZ.QUANG_CAO.COT_CHIEN_DICH'),
      t('BONBOZ.QUANG_CAO.COT_NHOM'),
      t('BONBOZ.QUANG_CAO.COT_AD'),
      'Ad ID',
      t('BONBOZ.QUANG_CAO.COT_KHACH'),
      t('BONBOZ.QUANG_CAO.COT_SDT'),
      t('BONBOZ.QUANG_CAO.COT_TI_LE'),
      t('BONBOZ.CAM_XUC.O_TICH_CUC'),
      t('BONBOZ.CAM_XUC.O_TIEU_CUC'),
    ],
    ...cacAd.value.map(a => [
      a.chien_dich,
      a.nhom,
      a.ten,
      a.ad_id,
      a.khach,
      a.sdt,
      `${a.ti_le}%`,
      a.tich_cuc,
      a.tieu_cuc,
    ]),
  ]);
};
</script>

<template>
  <ReportHeader
    :header-title="$t('BONBOZ.QUANG_CAO.TIEU_DE')"
    :header-description="$t('BONBOZ.QUANG_CAO.MO_TA')"
  />

  <div class="flex flex-col gap-4">
    <OverviewReportFilters :disabled="dangTai" @filter-change="doiBoLoc" />

    <PhamVi />

    <!-- TAB PHẠM VI — cùng khuôn bốn trang kia. Nằm NGOÀI nhánh đang-tải/trống
         để soi một trang không có quảng cáo vẫn quay về Tổng được. -->
    <div
      v-if="cacTrangChon.length > 1"
      class="flex flex-wrap items-center gap-1 p-1.5 border rounded-xl border-n-strong bg-n-slate-2 w-fit max-w-full"
      role="tablist"
    >
      <button
        v-for="tab in [
          { id: null, ten: $t('BONBOZ.TRANG_TK.BANG_TONG') },
          ...cacTrangChon.map(hop => ({ id: Number(hop.id), ten: hop.name })),
        ]"
        :key="tab.id ?? 'tong'"
        role="tab"
        :aria-selected="bangCua === tab.id"
        :disabled="dangTai"
        class="px-3.5 py-1.5 text-xs rounded-lg transition-colors whitespace-nowrap"
        :class="
          bangCua === tab.id
            ? 'bg-n-brand text-white font-medium shadow-sm'
            : 'text-n-slate-11 hover:bg-n-alpha-2 hover:text-n-slate-12'
        "
        @click="chonBang(tab.id)"
      >
        {{ tab.ten }}
      </button>
    </div>

    <div
      v-if="dangTai"
      class="flex items-center justify-center gap-2 py-16 text-sm text-n-slate-11"
    >
      <Spinner :size="24" class="text-n-brand" />
      {{ $t('BONBOZ.QUANG_CAO.DANG_TAI') }}
    </div>

    <EmptyState v-else-if="!coSoLieu" :title="$t('BONBOZ.QUANG_CAO.CHUA_CO')" />

    <template v-else>
      <!-- ====== QUẢNG CÁO vs TỰ NHIÊN — tiền mua khách có đáng không ====== -->
      <div v-if="soSanh" class="grid gap-3 sm:grid-cols-2">
        <div
          v-for="nguon in [
            {
              khoa: 'qc',
              ten: $t('BONBOZ.QUANG_CAO.TU_QUANG_CAO'),
              so: soSanh.quang_cao,
              dam: true,
            },
            {
              khoa: 'tn',
              ten: $t('BONBOZ.QUANG_CAO.TU_NHIEN'),
              so: soSanh.tu_nhien,
              dam: false,
            },
          ]"
          :key="nguon.khoa"
          class="p-4 border rounded-xl bg-n-solid-2"
          :class="nguon.dam ? 'border-n-brand' : 'border-n-weak'"
        >
          <p class="m-0 text-xs font-medium text-n-slate-11">{{ nguon.ten }}</p>
          <p class="flex items-baseline gap-2 m-0 mt-1">
            <span class="text-2xl font-medium tabular-nums text-n-slate-12">
              {{ nguon.so.ti_le }}%
            </span>
            <span class="text-xs text-n-slate-11">
              {{ $t('BONBOZ.QUANG_CAO.TI_LE_RA_SO') }}
            </span>
          </p>
          <p class="m-0 mt-1 text-xs tabular-nums text-n-slate-11">
            {{
              $t('BONBOZ.QUANG_CAO.KHACH_VA_SDT', {
                khach: nguon.so.khach,
                sdt: nguon.so.sdt,
              })
            }}
          </p>
        </div>
      </div>

      <!-- ====== BIỂU ĐỒ: khách từ QC vs tự nhiên theo ngày ====== -->
      <section class="p-4 border rounded-xl border-n-weak bg-n-solid-2">
        <h3 class="m-0 mb-3 text-sm font-medium text-n-slate-12">
          {{ $t('BONBOZ.QUANG_CAO.BIEU_DO') }}
        </h3>
        <div class="h-56">
          <BieuDoCamXuc
            :nhan="nhanBieuDo"
            :tich-cuc="chuoiNgay.map(d => d.quang_cao)"
            :tieu-cuc="chuoiNgay.map(d => d.tu_nhien)"
            :ten-tich-cuc="$t('BONBOZ.QUANG_CAO.TU_QUANG_CAO')"
            :ten-tieu-cuc="$t('BONBOZ.QUANG_CAO.TU_NHIEN')"
          />
        </div>
      </section>

      <!-- ====== CÂY: chiến dịch ▸ quảng cáo ====== -->
      <section class="border rounded-xl border-n-strong bg-n-solid-2">
        <div class="flex items-center justify-between p-4 pb-3">
          <h3 class="m-0 text-sm font-medium text-n-slate-12">
            {{ $t('BONBOZ.QUANG_CAO.BANG_CAY') }}
          </h3>
          <Button
            variant="ghost"
            color="slate"
            size="sm"
            icon="i-lucide-download"
            :label="$t('BONBOZ.XUAT.NUT')"
            @click="xuatExcel"
          />
        </div>

        <div class="overflow-x-auto">
          <table class="w-full text-sm border-collapse">
            <thead class="bg-n-slate-2">
              <tr class="text-xs border-y border-n-strong text-n-slate-11">
                <th class="px-4 py-2 font-normal text-start">
                  {{ $t('BONBOZ.QUANG_CAO.COT_CHIEN_DICH') }}
                </th>
                <th class="px-3 py-2 font-normal text-end">
                  {{ $t('BONBOZ.QUANG_CAO.COT_KHACH') }}
                </th>
                <th class="px-3 py-2 font-normal text-end">
                  {{ $t('BONBOZ.QUANG_CAO.COT_SDT') }}
                </th>
                <th
                  v-tooltip.top="$t('BONBOZ.QUANG_CAO.GT_TI_LE')"
                  class="px-3 py-2 font-normal text-end"
                >
                  {{ $t('BONBOZ.QUANG_CAO.COT_TI_LE') }}
                </th>
                <th
                  v-tooltip.top="$t('BONBOZ.QUANG_CAO.GT_CAM_XUC')"
                  class="px-3 py-2 font-normal text-end whitespace-nowrap"
                >
                  {{ $t('BONBOZ.QUANG_CAO.COT_CAM_XUC') }}
                </th>
              </tr>
            </thead>

            <tbody>
              <template v-for="nhom in cay" :key="nhom.ten">
                <!-- dòng CHIẾN DỊCH — bấm để mở/thu -->
                <tr
                  class="border-b cursor-pointer border-n-weak bg-n-alpha-1 hover:bg-n-alpha-2"
                  @click="doiMo(nhom.ten)"
                >
                  <td class="px-4 py-2.5 font-medium text-n-slate-12">
                    <span class="flex items-center gap-1.5">
                      <span
                        class="size-3.5 shrink-0"
                        :class="
                          dangMo.has(nhom.ten)
                            ? 'i-lucide-chevron-down'
                            : 'i-lucide-chevron-right'
                        "
                        aria-hidden="true"
                      />
                      {{ nhom.ten }}
                      <span class="text-xs font-normal text-n-slate-11">
                        {{
                          $t('BONBOZ.QUANG_CAO.SO_AD', { n: nhom.ads.length })
                        }}
                      </span>
                    </span>
                  </td>
                  <td class="px-3 py-2.5 tabular-nums text-end text-n-slate-12">
                    {{ nhom.khach }}
                  </td>
                  <td class="px-3 py-2.5 tabular-nums text-end text-n-slate-12">
                    {{ nhom.sdt }}
                  </td>
                  <td
                    class="px-3 py-2.5 font-medium tabular-nums text-end text-n-slate-12"
                  >
                    {{ nhom.ti_le }}%
                  </td>
                  <td class="px-3 py-2.5" />
                </tr>

                <!-- dòng QUẢNG CÁO — ảnh + tên + nhóm QC -->
                <tr
                  v-for="ad in dangMo.has(nhom.ten) ? nhom.ads : []"
                  :key="ad.id"
                  class="border-b border-n-weak hover:bg-n-alpha-1"
                >
                  <td class="py-2 pe-3 ps-10">
                    <div class="flex items-center gap-2.5">
                      <img
                        v-if="ad.anh"
                        :src="ad.anh"
                        alt=""
                        class="object-cover rounded size-9 shrink-0 bg-n-alpha-2"
                      />
                      <span
                        v-else
                        class="grid rounded size-9 shrink-0 bg-n-alpha-2 place-items-center"
                      >
                        <span
                          class="i-lucide-megaphone size-4 text-n-slate-10"
                          aria-hidden="true"
                        />
                      </span>
                      <span class="min-w-0">
                        <a
                          v-if="ad.lien_ket"
                          :href="ad.lien_ket"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="block text-sm truncate rounded text-n-brand hover:underline max-w-[22rem]"
                        >
                          {{ ad.ten }}
                        </a>
                        <span
                          v-else
                          class="block text-sm truncate text-n-slate-12 max-w-[22rem]"
                        >
                          {{ ad.ten }}
                        </span>
                        <span
                          v-if="ad.nhom"
                          class="block text-xs truncate text-n-slate-11 max-w-[22rem]"
                        >
                          {{ ad.nhom }}
                        </span>
                      </span>
                    </div>
                  </td>
                  <td class="px-3 py-2 tabular-nums text-end text-n-slate-12">
                    {{ ad.khach }}
                  </td>
                  <td class="px-3 py-2 tabular-nums text-end text-n-slate-12">
                    {{ ad.sdt }}
                  </td>
                  <td class="px-3 py-2 tabular-nums text-end text-n-slate-12">
                    {{ ad.ti_le }}%
                  </td>
                  <td class="px-3 py-2 text-end whitespace-nowrap">
                    <span
                      v-if="ad.tich_cuc"
                      class="text-xs tabular-nums text-n-teal-11"
                    >
                      {{ `▲${ad.tich_cuc}` }}
                    </span>
                    <span
                      v-if="ad.tieu_cuc"
                      class="text-xs tabular-nums text-n-ruby-11 ms-1.5"
                    >
                      {{ `▼${ad.tieu_cuc}` }}
                    </span>
                    <span
                      v-if="!ad.tich_cuc && !ad.tieu_cuc"
                      class="text-xs text-n-slate-10"
                    >
                      —
                    </span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </section>
    </template>
  </div>
</template>
